// Dispatch — ADMIN (operations) workspace page.

import React from 'react';
import OpsLayout from '../../components/layout/OpsLayout.jsx';
import DispatchBoard from '../../components/ops/DispatchBoard.jsx';
import { opsDispatchApi } from '../../api/opsApi';

const OpsDispatchPage = () => (
  <OpsLayout>
    <DispatchBoard api={opsDispatchApi} />
  </OpsLayout>
);

export default OpsDispatchPage;
